import * as React from 'react';

import {ListViewInfiniteLoading as ListViewLoadingIcon} from 'shells/list-view/list-view-infinite-loading';
import {ListViewSpecialStateText} from 'shells/list-view/list-view-special-state-text';
import {PopoverList} from 'shells/popover/popover-list';

import {getCollection, renderLeadCard} from './helpers';
import {useGetPeepRelatedLeadCards} from './sources/hooks/use-get-peep-related-lead-cards';

type Props = {
    peepId: string;
    onNavigate: () => void;
    title: string;
    showChildLeadInfo?: boolean;
};

export const PeepRelatedLeadCards = (props: Props) => {
    const {peepId, title, showChildLeadInfo} = props;
    const {isLoading, errorMessage, peep} = useGetPeepRelatedLeadCards(peepId);
    const entityType = props.peepId.split('-')[1];

    const relatedLeadsListLink = `/leads?filter[${entityType}][data][0][data]=${peepId}&view=list`;
    const childLeadsListLink = `/leads?filter[parentAccount][data][0][data]=${peepId}&view=list`;

    return (
        <PopoverList
            title={title}
            viewAllLink={showChildLeadInfo ? childLeadsListLink : relatedLeadsListLink}
            height={400}
            collection={getCollection(peep, showChildLeadInfo)}
            renderRow={(edge) => renderLeadCard(edge, props.onNavigate)}
            isLoading={isLoading}
            loadingState={{customComponent: <ListViewLoadingIcon />}}
            specialStates={[
                {
                    shouldRender: () => Boolean(errorMessage),
                    component: (
                        <ListViewSpecialStateText text='Oh no! Something went wrong loading these leads' />
                    ),
                },
            ]}
        />
    );
};
